import React, { useState } from 'react'
import { TASK_STATUS_TYPES, TASK_TYPES, TASK_TYPE_ICON_MAP } from '../constants'
import {
  Box,
  Button,
  IconButton,
  MenuItem,
  TableCell,
  TableRow,
  TextField,
  Typography,
} from '@mui/material'
import useIsMobile from '../hooks/useIsMobile'
import { Check } from '@mui/icons-material'
import { TaskOutcomeModal } from '../common/TaskOutcome'

const getTaskColor = (dateIsInFuture, dateIsToday, isComplete) => {
  if (isComplete) return 'rgb(26 192 26 / 60%)'
  if (dateIsInFuture) return 'white'
  if (dateIsToday) return 'rgb(253 221 51 / 70%)'

  return 'rgba(255, 0, 0, 0.3)'
}

const TaskItem = ({
  task: t,
  updateTask,
  saveTask,
  taskTypes,
  taskStatusTypes,
  updateTaskStatus,
  setCurrentTask,
  setCurrentOpenModal,
}) => {
  const [isEditingDates, setIsEditingDates] = useState(false)

  const now = new Date()

  const isMobile = useIsMobile()

  const createdOn = t?.createdOn ? new Date(t.createdOn) : null

  const createdOnString = createdOn ? createdOn.toLocaleDateString() : 'None'

  // Add timezone offset to the date so that it doesn't print as the day before
  const date = t.date
    ? new Date(
        new Date(t.date).getTime() + new Date().getTimezoneOffset() * 60 * 1000
      )
    : null

  const dateLocalString = date ? date.toLocaleDateString() : 'None'

  const dateIsInFuture = date > now
  const dateIsToday = date.toDateString() === now.toDateString()

  const Icon = TASK_TYPE_ICON_MAP[t.taskTypeId]

  const isComplete = t.statusTypeId === 3
  const isCanceled = t.statusTypeId === 4
  const color = getTaskColor(dateIsInFuture, dateIsToday, isComplete)

  return (
    <TableRow
      key={t.id}
      sx={{
        textDecoration: isComplete || isCanceled ? 'line-through' : null,
        backgroundColor: color,
      }}
    >
      {!isMobile && <TableCell>{createdOnString}</TableCell>}

      <TableCell>
        {!isEditingDates && (
          <Typography
            sx={{ cursor: 'pointer' }}
            onClick={() => setIsEditingDates(true)}
          >
            {dateLocalString}
          </Typography>
        )}
        {isEditingDates && (
          <Box sx={{ display: 'flex' }}>
            <TextField
              size='small'
              type='date'
              value={date.toLocaleDateString('sv')}
              onChange={(e) => {
                updateTask(t, { date: e.target.value })
              }}
            ></TextField>
            <IconButton
              onClick={() => {
                setIsEditingDates(false)
                saveTask(t)
              }}
            >
              <Check color='primary' />
            </IconButton>
          </Box>
        )}
      </TableCell>

      <TableCell>
        {!!Icon ? (
          <IconButton
            onClick={() => {
              setCurrentTask(t)
              setCurrentOpenModal(t.taskTypeId)
            }}
          >
            <Icon />
          </IconButton>
        ) : (
          <Box sx={{ width: '40px', height: '40px' }} />
        )}
        {taskTypes.find((tt) => tt.id === t.taskTypeId).name}
      </TableCell>
      <TableCell>
        <Button href={`/customers/${t.customerId}`}>{t.customerName}</Button>
        {/* <Typography>{t.contactName}</Typography> */}
      </TableCell>
      {/* <TableCell>{t.note}</TableCell> */}
      <TableCell>
        {t.taskTypeId !== TASK_TYPES.SCHEDULE_EVENT && (
          <StatusDropdown
            updateTaskStatus={updateTaskStatus}
            t={t}
            taskStatusTypes={taskStatusTypes}
          />
        )}
      </TableCell>
    </TableRow>
  )
}

export const StatusDropdown = ({ updateTaskStatus, t, taskStatusTypes }) => {
  const [modalOpen, setModalOpen] = useState(false)

  const [val, setVal] = useState(t.statusTypeId)

  const handleChange = (e) => {
    if (e.target.value === TASK_STATUS_TYPES.DONE) {
      setVal(e)
      setModalOpen(true)
    } else {
      updateTaskStatus(t, e)
    }
  }
  return (
    <>
      <TextField
        sx={{ backgroundColor: 'white' }}
        fullWidth
        value={t.statusTypeId}
        onChange={handleChange}
        select
        size='small'
      >
        {taskStatusTypes.map((tst, i) => (
          <MenuItem key={i} value={tst.id}>
            {tst.name}
          </MenuItem>
        ))}
      </TextField>

      {modalOpen && (
        <TaskOutcomeModal
          onClose={() => setModalOpen(false)}
          open={modalOpen}
          task={t}
          onSave={() => {
            updateTaskStatus(t, val)
            setModalOpen(false)
          }}
        ></TaskOutcomeModal>
      )}
    </>
  )
}

export default TaskItem
